import $ from "jquery";

class CustomCollage {
    constructor() {
        this.wordpressCssClass();
        this.showElement(".upper-section", ".image-top", 50);
        this.showElement(".video-section", ".image-middle-position", 150);
        this.showElement(".lower-section", ".image-bottom", 50);
        this.showElementOnScroll();
    }

    showElementOnScroll() {
        const $self = this;
        $(window).scroll(function () {
            $self.showElement(".upper-section", ".image-top", 50);
            $self.showElement(".video-section", ".image-middle-position", 150);
            $self.showElement(".lower-section", ".image-bottom", 50);
        });
    }

    showElement(divSection, imagePos, extraPxls) {
        const div = $(divSection),
            pos = div.position(),
            windowPos = $(window).scrollTop();

        if (!div.length) {
            return;
        }

        if ((windowPos) >= (pos.top + extraPxls)) {
            if (divSection === ".video-section") {
                $("iframe").addClass("show-element");
            }
            $(imagePos).addClass("show-element");
        }
    }

    wordpressCssClass() {
        if ($(".fluid-width-video-wrapper").length) { // Wordpress adds a div with a padding-top and inside embeded the iframe YouTube video
            $(".fluid-width-video-wrapper").removeAttr("style");
        }
    }
}

export default CustomCollage;